/**
 * Initiële state voor settings
 */
import { combineReducers } from '@ngrx/store';
import { reducer as adminDefinitionsReducer } from 'app/core/store/admin/admin-definitions/admin-definitions.reducer';
import { AdminState } from 'app/core/store/admin/admin.interface';
import { ADMIN_INITIAL_STATE } from 'app/core/store/admin/admin.model';
import { reducer as adminClientUsersReducer } from 'app/core/store/admin/users/client-users.reducer';
import { reducer as adminEditUserReducer } from 'app/core/store/admin/users/edit-user.reducer';
import { reducer as adminEpsUsersReducer } from 'app/core/store/admin/users/eps-users.reducer';
import { reducer as userSyncWithADReducer } from 'app/core/store/admin/users/sync-users.reducer';

export function reducer(state = ADMIN_INITIAL_STATE, action: any): AdminState {
  return combineReducers({
    epsUsers: adminEpsUsersReducer,
    clientUsers: adminClientUsersReducer,
    adminDefinitions: adminDefinitionsReducer,
    edit: adminEditUserReducer,
    sync: userSyncWithADReducer,
  })(state, action);
}
